import http from './request'

// // 获取学校大数组
export function getScList () {
  return http({
    method: 'get',
    url: '/api/web/queryNewsClass'
  })
}
// 按分类查询的各个数组
export function postNewsByPage (classId, page, size) {
  // const url =
  return http({
    method: 'get',
    url: `/api/web/queryNewsByPage?classId=${classId}&page=${page}&size=${size}`
  })
}
// 按分类id查询详情页
export function getDetails (newsId) {
  return http({
    method: 'get',
    url: `/api/web/queryNewsById?newsId=${newsId}`
  })
}
// 附件接口
export function getFiles (fileId) {
  return http({
    method: 'get',
    url: `/api/web/download?fileId=${fileId}`
  })
}

// 在线报名
export function postOnline (obj) {
 console.info(obj,'接口里面推荐人')
  return http({
    method: 'post',
    url: '/api/web/register/submit',
    data:obj
    // data: {
    //   subjectType,
    //   subjectSubType,
    //   name,
    //   idCard,
    //   sex,
    //   phone,
    //   lastSchool,
    //   homeAddress,
    //   remark,
    //   simulationScore,
    //   entranceScore,
    //   isFilingRegistration,
    //   previousSessions,
    //   reference
    // }
  })
}
// 在线报名
export function editOnline (obj) {
  return http({
    method: 'post',
    url: '/api/web/register/update',
    data:obj
    // data: {
    //   subjectType,
    //   subjectSubType,
    //   name,
    //   idCard,
    //   id,
    //   sex,
    //   phone,
    //   lastSchool,
    //   homeAddress,
    //   remark,
    //   simulationScore,
    //   entranceScore,
    //   isFilingRegistration,
    //   previousSessions,
    //   reference
    // }
  })
}

// 查询父专业
export function getFartherPrj () {
  return http({
    methods: 'get',
    url: `/api/web/register/querySubjectType`
  })
}

// 查询子专业
export function getChilPrj (parentId) {
  return http({
    methods: 'get',
    url: `/api/web/register/querySubjectSubType?parentId=${parentId}`
  })
}

// 查询毕业学校
export function getLastSchool () {
  return http({
    methods: 'get',
    url: `/api/web/register/queryLastSchool`
  })
}
// 骨干申报材料
// export function getFileView() {
//   return http({
//     methods: 'get',
//     url: '/api/web/file'
//   })
// }

export function getFileView () {
  return http({
    methods: 'get',
    url: '/api/web/file'
  })
}
// 按分类查询的各个数组 报名列表
export function applyList (page, size) {
  // const url =
  return http({
    method: 'get',
    url: `/api/web/register/list?page=${page}&size=${size}`
  })
}
// 按分类查询的各个数组 报名统计
export function applyCount () {
  // const url =
  return http({
    method: 'get',
    url: `/api/web/register/count`
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js